import MenuBar from "../Component/MenuBar";
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";
import { NavLink } from "react-router-dom";

const FallFestival = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* Page Banner */}
            <section className="page-banner">
                <div className="image-layer" style={{ backgroundImage: 'url(https://sevastorage.blob.core.windows.net/seva-blob/Yugalkunj_website/background/bg-page-title-2.jpg)' }}></div>
                <div className="auto-container">
                    <h1>Fall Festival 2026</h1>
                </div>
                <div className="breadcrumb-box">
                    <div className="auto-container">
                        <ul className="bread-crumb clearfix">
                            <li><NavLink to="/USA/Home">Home</NavLink></li>
                            <li className="active">Fall Festival 2026</li>
                        </ul>
                    </div>
                </div>
            </section>

            <div className="container" style={{ paddingBottom: "40px" }}>

                {/* Heading */}
                <div className="auto-container">
                    <div className="centered">
                        <hr />
                        <h3>Fall Festival 2026</h3>
                        <h4 className="text-center" style={{ color: "#666", marginTop: "8px" }}>
                            Friday, September 25th, 2026
                        </h4>
                        <h5 className="text-center" style={{ color: "#888", marginTop: "5px" }}>
                            Yugal Kunj &nbsp;·&nbsp; 2769 Duluth Hwy, Duluth, GA 30096
                        </h5>
                        <p className="text-center" style={{ marginTop: "12px", fontStyle: "italic", color: "#e67e22", fontSize: "16px" }}>
                            A night of joy, community &amp; fun for all ages!
                        </p>
                        <hr />
                    </div>
                </div>

                {/* Flyer */}
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Fall Festival 2026 – Event Flyer</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="widget-49">
                                    <figure className="image">
                                        <img
                                            src="https://stssevastorage.blob.core.windows.net/media/hyc/events/image/1/a589b86f_Fall_Festival.jpeg"
                                            alt="Fall Festival 2026"
                                            style={{ width: "100%" }}
                                        />
                                        <a
                                            href="https://stssevastorage.blob.core.windows.net/media/hyc/events/image/1/a589b86f_Fall_Festival.jpeg"
                                            className="lightbox-image overlay"
                                            data-fancybox="gallery-fallfestival"
                                        ></a>
                                    </figure>
                                    <br />
                                    <div className="widget-49-meeting-action">
                                        <a
                                            href="https://stssevastorage.blob.core.windows.net/media/hyc/events/image/1/a589b86f_Fall_Festival.jpeg"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-sm btn-flash-border-primary"
                                        >
                                            View Flyer
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Event Highlights */}
                <hr />
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Event Highlights</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title orange-border">
                                    <ul className="satsang_list">
                                        <li><strong>Games for All Ages</strong></li>
                                        <li><strong>Face Painting</strong></li>
                                        <li><strong>Bouncy House</strong></li>
                                        <li><strong>Raffle Prizes</strong></li>
                                        <li><strong>Community Fun &amp; More!</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Event Details */}
                <hr />
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Event Details</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title orange-border">
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '15px' }}>
                                        <tbody>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#e67e22', width: '140px' }}>Event</td>
                                                <td style={{ padding: '10px 12px' }}>Fall Festival 2026</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee', background: '#fafafa' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#e67e22' }}>Date</td>
                                                <td style={{ padding: '10px 12px' }}>Friday, September 25th, 2026</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#e67e22' }}>Venue</td>
                                                <td style={{ padding: '10px 12px' }}>Yugal Kunj</td>
                                            </tr>
                                            <tr style={{ background: '#fff8e1' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#e67e22' }}>Address</td>
                                                <td style={{ padding: '10px 12px' }}>2769 Duluth Hwy, Duluth, GA 30096</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Location */}
                <hr />
                <div className="row" style={{ marginBottom: "30px" }}>
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Location</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title purple-border" style={{ paddingLeft: "20px" }}>
                                    <h4>Yugal Kunj</h4>
                                    <p>2769 Duluth Hwy, Duluth, GA 30096</p>
                                    <p><strong>Date:</strong> Friday, September 25th, 2026</p>
                                    <br />
                                    <a
                                        href="https://maps.google.com/?q=2769+Duluth+Hwy,+Duluth,+GA+30096"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-sm btn-flash-border-primary"
                                    >
                                        Open in Google Maps
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <Footer />
        </>
    );
};

export default FallFestival;
